//import TimePlan from './TimePlan';
import TimePlan2 from './TimePlanTwo';

export default TimePlan2;


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/index.js